import styled from 'styled-components';

import { brandFont } from 'components/layout/brand-font';

export const ModalBody = styled.div`
  width: 100%;
  padding: 0 1.5rem;
  position: absolute;
  top: 45%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
`;

export const Heading = styled.h2`
  margin: 0;
  font-family: ${Styles.fontFamily.base};
  text-align: center;
  font-weight: normal;
  font-size: 2rem;
`;

export const Info = styled.p`
  margin: 0;
  font: ${brandFont.copyOne};
  text-align: center;
`;
